/**
 * Program: i18n
 * Author: SDL
 * Description: i18n language setting file
 */
// https://kazupon.github.io/vue-i18n/guide/lazy-loading.html
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import axios from 'axios';
import isEmpty from 'lodash/isEmpty';
import store from '@/vuex/store';
import SDLUtil from '@/utils/SDLUtil';

Vue.use(VueI18n);

const defaultLanguage = (window.navigator.userLanguage || window.navigator.language || SDLUtil.DEFAULT_LANG).replace('-', '_');
export const i18n = new VueI18n({
  locale: defaultLanguage, // set locale
  fallbackLocale: defaultLanguage,
  messages: {}, // set locale messages
});

let loadedLanguages = []; // our default language that is preloaded

function setI18nLanguage(lang) {
  i18n.locale = lang;
  store.commit('LOCALE', lang);
  axios.defaults.headers.common['Accept-Language'] = lang;
  document.querySelector('html').setAttribute('lang', lang);
  return lang;
}

export async function loadLanguageAsync(lang) {
  let language;
  if (isEmpty(loadedLanguages)) {
    await axios.get(`${SDLUtil.API_URL}/noauth/messages/all`).then(msgs => {
      loadedLanguages = Object.keys(msgs.data);
      loadedLanguages.forEach(country => {
        i18n.setLocaleMessage(country, msgs.data[country]);
      });
    });
  }
  try {
    language = loadedLanguages.find(find => find === lang)
      || loadedLanguages.find(find => find.includes(lang.split('_')[0]))
      || SDLUtil.DEFAULT_LANG;
  } catch (e) {
    language = SDLUtil.DEFAULT_LANG;
  }
  return setI18nLanguage(language);
}

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/index.js